import styled from 'styled-components';

interface MainProps {
  $centered: boolean;
  $ambossOverlayOpen: boolean;
  /** Bounds `<main>` to the viewport instead of growing with content, so a screen that manages
   * its own scroll region (rather than relying on the document scrolling) can actually bound it. */
  $fillViewport: boolean;
}

export const Main = styled.main.attrs<MainProps>((props) => ({
  className: `${props.$fillViewport ? 'h-screen overflow-hidden' : 'min-h-screen'} bg-background focus:outline-none ${props.$centered ? 'flex flex-col' : ''} ${
    props.$ambossOverlayOpen ? 'overflow-hidden h-100' : ''
  }`,
}))<MainProps>``;

export const CenteredContent = styled.div.attrs({
  className: 'flex flex-1 items-center justify-center',
})``;
